import React from 'react';

function AuthLeft() {
    return (
        <div
            style={{
                flex: '0 0 50%',
                display: 'none',
                background: 'linear-gradient(45deg, #45afaf, #0d6efd)',
                minHeight: '100vh',
                justifyContent: 'center',
                alignItems: 'center'
            }}
            className="d-lg-flex"
        >
            <div style={{ maxWidth: '25rem', textAlign: 'center' }}>
                <div className="mb-4">
                    <div
                        className="d-inline-flex align-items-center justify-content-center rounded-circle mb-4"
                        style={{
                            width: '120px',
                            height: '120px',
                            backgroundColor: 'rgba(255,255,255,0.2)'
                        }}
                    >
                        <i className="bi bi-bag-check-fill" style={{ fontSize: '60px', color: '#fff' }}></i>
                    </div>
                </div>
                <div className="mb-4">
                    <h1 className="text-white fw-bold mb-3">Poly-Lite</h1>
                    <h4 className="text-white" style={{ opacity: 0.9 }}>Admin Panel</h4>
                </div>
                <div>
                    <p className="text-white mb-0" style={{ opacity: 0.8 }}>
                        Comprehensive management system for your business
                    </p>
                </div>
            </div>
        </div>
    );
}
export default AuthLeft;
